import HeaderMenu from './header';
import EventsFilterData from './events-filter';
import ArchiveFilter from './filter-post';
import { initBlocIndicateurs } from './accordion';
import { initBlocActionsTabs } from './bloc-actions-tabs';
import { initBlocListeAncres } from './bloc-liste-ancres';

window.addEventListener('DOMContentLoaded', function () {
  new HeaderMenu();
  new ArchiveFilter();
  new EventsFilterData();
  initBlocIndicateurs();
  initBlocActionsTabs();
  initBlocListeAncres();
});
